import { apiClient, extractList } from './client';
import type {
  ActiveStatusEffectEntry,
  ApplyStatusEffectPDTO,
  EntityStatusEffectModel,
  StatusEffectModel,
  StatusEffectTargetType,
} from '@/types/statusEffects';

const BASE = '/api/v1/EntityStatusEffect';
const CATALOG_BASE = '/api/v1/StatusEffect';

export async function fetchActiveStatusEffects(
  targetType: StatusEffectTargetType,
  targetId: number,
): Promise<ActiveStatusEffectEntry[]> {
  const { data } = await apiClient.get<ActiveStatusEffectEntry[]>(`${BASE}/active`, {
    params: { targetType, targetId },
  });
  return data;
}

export async function applyStatusEffect(body: ApplyStatusEffectPDTO): Promise<EntityStatusEffectModel> {
  const { data } = await apiClient.post<EntityStatusEffectModel>(`${BASE}/apply`, body);
  return data;
}

/** Liste paginee du catalogue (pour le selecteur admin). */
export async function fetchStatusEffectCatalog(): Promise<StatusEffectModel[]> {
  const { data } = await apiClient.get(`${CATALOG_BASE}`, { params: { pageSize: 100 } });
  return extractList<StatusEffectModel>(data);
}
